import { ActionsMenu, ActionsMenuItem } from '@/components/ActionsMenu';
import TrashIcon from '@/components/Icons/TrashIcon';
import { useDeleteChain } from '@/pages/Chain/hooks';

import { ActionsProps } from './types';

function Actions({ variant, chainId, chainName, doNotRedirect }: ActionsProps) {
  const deleteChain = useDeleteChain(chainName, chainId, doNotRedirect);

  return (
    <ActionsMenu variant={variant}>
      <ActionsMenuItem
        destructive
        onClick={deleteChain}
        data-cy="chain-card-setting-delete-btn"
        icon={<TrashIcon />}
      >
        Delete chain
      </ActionsMenuItem>
    </ActionsMenu>
  );
}

export default Actions;
